import React, { useEffect, useState, useRef } from "react";
import {
    Button,
    Card,
    CardBody,
    CardTitle,
    Row,
    Col,
    Label,
    Input
} from "reactstrap";
import Select, { components } from "react-select";
import { useSelector, useDispatch } from "react-redux";

import {
    getCompanies as onGetCompanies,
    getListAccount as onGetListAccount,
    getListAccountNumber as onGetListAccountNumber,
    getPeriods as onGetPeriods,
    setPage as onSetPage,
    clearData as onClearData
} from '../../../store/actions'
import PulseLoader from "react-spinners/PulseLoader";

const Option = props => {
    return (
        <div style={{ display: "flex" }}>
            <components.Option {...props} />
            {props.data.totalApproval > 0 && <span className="badge bg-danger mx-3 align-self-center">{props.data.totalApproval}</span>}
        </div>
    );
};

const Filter = ({ onSubmit }) => {
    const dispatch = useDispatch();
    const [remarks, setRemarks] = useState(null)

    const [selectedCompany, setSelectedCompany] = useState(null);
    const [optionCompany, setOptionCompany] = useState([]);
    function handleSelectCompany(e) {
        setSelectedCompany(e);
    }

    const [selectedAccount, setSelectedAccount] = useState(null);
    const [optionAccount, setOptionAccount] = useState([]);
    function handleSelectAccount(e) {
        setSelectedAccount(e);
    }

    const [selectedAccountNumber, setSelectedAccountNumber] = useState(null);
    const [optionAccountNumber, setOptionAccountNumber] = useState([]);
    function handleSelectAccountNumber(e) {
        setSelectedAccountNumber(e);
    }

    const [selectedType, setSelectedType] = useState(null);
    const [optionType, setOptionType] = useState([
        { value: "credit", label: "CREDIT" },
        { value: "debit", label: "DEBIT" }
    ]);
    function handleSelectType(e) {
        setSelectedType(e);
    }

    const {
        companies,
        loadingCompany,
        loading,
        listAccount,
        loadingAccount,
        listAccountNumber,
        loadingAccountNumber,
        length
    } = useSelector(state => ({
        companies: state.Company.companies,
        loadingCompany: state.Company.loading,
        loading: state.Dashboard.loading,
        listAccount: state.Account.listAccount,
        loadingAccount: state.Account.loading,
        listAccountNumber: state.AccountNumber.listAccountNumber,
        loadingAccountNumber: state.AccountNumber.loadingNumber,
        length: state.DataTable.length,
    }));

    useEffect(() => {
        if (companies) {
            setOptionCompany(companies.map((item) => {
                return { label: item.name, value: item.id, totalApproval: item.approvalAccountTransaction }
            }))
        }
    }, [companies])

    useEffect(() => {
        if (listAccount) {
            setOptionAccount(listAccount.map((item) => {
                return { label: item.name, value: item.id }
            }))
        }
    }, [listAccount])

    useEffect(() => {
        if (listAccountNumber) {
            setOptionAccountNumber(listAccountNumber.map((item) => {
                return { label: item.name, value: item.id }
            }))
        }
    }, [listAccountNumber])

    var filterAccount = useRef(null)
    var filterAccountNumber = useRef(null)
    var filterType = useRef(null)
    var filterRemarks = useRef(null);

    const onRefreshCommand = () => {
        dispatch(onSetPage(1, length))
        if (selectedCompany) {
            let param = { companyId: selectedCompany.value }
            param = selectedAccount ? { ...param, accountId: selectedAccount.value } : param
            param = selectedAccountNumber ? { ...param, accountNumberId: selectedAccountNumber.value } : param
            param = selectedType ? { ...param, type: selectedType.value } : param
            param = remarks ? { ...param, remarks: remarks } : param
            onSubmit(param)
        }
    }

    const onResetFilterCommand = () => {
        clearFilter()
        if (selectedCompany) {
            onSubmit({ companyId: selectedCompany.value })
        }
    }

    const clearFilter = async () => {
        setSelectedAccount(null)
        setSelectedAccountNumber(null)
        setSelectedType(null)
        setRemarks(null)
        filterRemarks.current.value = null
    }

    useEffect(() => {
        if (dispatch) {
            dispatch(onClearData())
            dispatch(onGetCompanies({ calculateApprovalClient: true }));
        }
    }, [dispatch])

    useEffect(() => {
        if (selectedCompany) {
            filterAccount.current?.value?.clear();
            filterAccountNumber.current?.value?.clear();
            setSelectedAccount(null)
            setSelectedAccountNumber(null)
            dispatch(onClearData())
            dispatch(onGetListAccount({ companyId: selectedCompany.value }))
            dispatch(onGetListAccountNumber({ companyId: selectedCompany.value }))
            dispatch(onGetPeriods({ companyId: selectedCompany.value, isOpen : true }))
        }
    }, [selectedCompany])

    return <Card>
        <CardBody>
            <CardTitle>Filter</CardTitle>
            <Row>
                <Col sm={6}>
                    <div>
                        <Label>Company</Label>
                        <Select
                            value={selectedCompany}
                            onChange={handleSelectCompany}
                            options={optionCompany}
                            isLoading={loadingCompany}
                            components={{ Option }}
                            isClearable={false}
                            className="select2-selection"
                            menuPosition="fixed"
                        />
                    </div>
                </Col>
                <Col sm={6}>
                    <div>
                        <Label>Account</Label>
                        <Select
                            value={selectedAccount}
                            onChange={handleSelectAccount}
                            options={optionAccount}
                            isLoading={loadingAccount}
                            className="select2-selection"
                            menuPosition="fixed"
                            isClearable={true}
                            ref={filterAccount}
                        />
                    </div>
                </Col>
            </Row>
            <Row className="mt-3">
                <Col sm={4}>
                    <div>
                        <Label>Account Number</Label>
                        <Select
                            value={selectedAccountNumber}
                            onChange={handleSelectAccountNumber}
                            options={optionAccountNumber}
                            isLoading={loadingAccountNumber}
                            className="select2-selection"
                            menuPosition="fixed"
                            isClearable={true}
                            ref={filterAccountNumber}
                        />
                    </div>
                </Col>
                <Col sm={4}>
                    <div>
                        <Label>Type</Label>
                        <Select
                            value={selectedType}
                            onChange={handleSelectType}
                            options={optionType}
                            isLoading={false}
                            className="select2-selection"
                            menuPosition="fixed"
                            isClearable={true}
                            ref={filterType}
                        />
                    </div>
                </Col>
                <Col sm={4}>
                    <div>
                        <Label>Remarks</Label>
                        <Input
                            type="text"
                            value={remarks}
                            className="form-control"
                            innerRef={filterRemarks}
                            onChange={e => {
                                setRemarks(e.target.value)
                            }}
                            placeholder={'Enter ...'}
                        />
                    </div>
                </Col>
            </Row>
            <Row className="mt-3">
                <Col className="justify-content-end">
                    <Button color="primary" className="btn btn-primary waves-effect waves-light float-end" style={{ minWidth: '200px' }}
                        disabled={loading}
                        onClick={onRefreshCommand}>
                        {loading && <PulseLoader loading={loading} color={'#FFF'} size={8} className="align-self-center" />}
                        {!loading && <i className="bx bx-filter-alt"></i>}
                    </Button>
                    <Button color="secondary" className="btn btn-secondary waves-effect waves-light me-2 float-end" style={{ minWidth: '100px' }}
                        disabled={loading}
                        onClick={onResetFilterCommand}>
                        Clear
                    </Button>
                </Col>
            </Row>
        </CardBody>
    </Card>
}

export default Filter;